import { useDispatch, useSelector } from 'react-redux';
import useClientForm from '../../hooks/useClientForm';
import { setEditClient, updateClient } from '../../redux/actions/clients';
import { StoreState } from '../../types/state';
import EditDialog from '../Common/EditDialog';

const EditClient = () => {
  const { clientFormSchema, updated } = useClientForm();
  const dispatch = useDispatch();
  const client = useSelector((state: StoreState) => state.clients.editClient);

  if (!client || !updated) return null;

  const handleUpdate = (data: any) => {
    dispatch(updateClient({ data }));
  };
  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => dispatch(setEditClient(undefined))}
      formSchema={clientFormSchema}
      formData={client}
    />
  );
};
export default EditClient;
